import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Modal } from "antd";

import moment from "moment";

class ModalMap extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			avatar: null,
			dataHora: ""
		};
	}

	resetFields = () => {};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	onOpen = (avatar, dataHora) => {
		this.setState({
			avatar,
			dataHora
		});
	};

	render() {
		const { avatar, dataHora } = this.state;
		const { visible } = this.props;

		return (
			<Modal
				visible={visible}
				title={(
					<div className="time-card-modal-header">
						<span className="time-card-modal-header-icon"><i className="fal fa-portrait" /></span>
						<div className="time-card-modal-title">
							Imagem <span>[{moment(dataHora).format("DD/MM/YYYY - HH:mm:ss")}]</span>
						</div>
					</div>
				)}
				wrapClassName="modal-scroll"
				className="time-card-modal"
				destroyOnClose={true}
				width={500}
				onCancel={this.onClose}
				centered
				footer={null}
			>
				<div style={{ width: "100%" }}>
					<img src={avatar} width="100%" />
				</div>
			</Modal>
		);
	}
}

export default ModalMap;